export default "__VITE_ASSET__BePJpVur__"